import { Box } from "@mui/material";
import React from "react";
import CallStatusTrends from "./CallStatusTrends";
import CarCompanyTrends from "./CarCompanyTrends";
import CustomerTrends from "./CustomerTrends";

const EnquiryAnalytics = () => {
  return (
    <>
      <Box
        m="2rem 0"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        maxHeight={300}
        gap={2}
      >
        <Box
          display="flex"
          flexDirection="column"
          width="40%"
          className="bg-slate-50 rounded-lg p-2 border-slate-500 align-middle "
          sx={{
            border: '1px solid'
          }}
        >
          <h4 className="text-center font-extrabold text-[0.72rem] leading-[0.5rem] text-[#666] mt-3">
            Car Company Trends
          </h4>
          <CarCompanyTrends />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="30%"
          className="bg-slate-50 rounded-lg p-2 border-slate-500 align-middle justify-center"
          sx={{
            border: '1px solid'
          }}
        >
          <CustomerTrends />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="30%"
          className="bg-slate-50 rounded-lg p-2 border-slate-500 align-middle justify-center"
          sx={{
            border: '1px solid'
          }}
        >
          <CallStatusTrends />
        </Box>
      </Box>
    </>
  );
};

export default EnquiryAnalytics;
